import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/api";
import Layout from "../components/Layout";

export default function EditRound() {
  const { interviewId, roundId } = useParams();
  const navigate = useNavigate();
  const [round, setRound] = useState({ name: "", description: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!interviewId || !roundId) {
      console.error("❌ Missing interviewId or roundId in URL");
      setLoading(false);
      return;
    }

    const fetchRound = async () => {
      try {
        // 📦 Get all rounds for this interview
        const res = await api.get(`/interviews/${interviewId}/rounds`);
        const rounds = res.data.rounds || [];
        const foundRound = rounds.find(
          (r) => r.id === parseInt(roundId)
        );

        if (!foundRound) {
          alert("Round not found.");
          navigate(`/interviews/${interviewId}`);
          return;
        }

        setRound({ name: foundRound.name, description: foundRound.description });
      } catch (err) {
        console.error("❌ Failed to fetch round:", err);
        alert("Failed to load round details.");
      } finally {
        setLoading(false);
      }
    };

    fetchRound();
  }, [interviewId, roundId, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRound((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put(`/rounds/${roundId}`, {
        name: round.name,
        description: round.description,
      });
      alert("✅ Round updated successfully!");
      navigate(`/interviews/${interviewId}`);
    } catch (err) {
      console.error("❌ Failed to update round:", err);
      alert("Failed to update round.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <h2 className="text-lg font-semibold">Loading Round Details...</h2>
      </Layout>
    );
  }

  return (
    <Layout>
      <h2 className="text-2xl font-bold mb-4">✏️ Edit Round</h2>
      <form onSubmit={handleSubmit} className="max-w-md space-y-4">
        <div>
          <label className="block text-gray-700 mb-1">Round Name</label>
          <input
            type="text"
            name="name"
            value={round.name}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter round name"
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-1">Description</label>
          <textarea
            name="description"
            value={round.description}
            onChange={handleChange}
            rows="4"
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter round description"
          />
        </div>
        <div className="flex space-x-2">
          <button
            type="submit"
            disabled={saving}
            className={`bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 ${
              saving ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {saving ? "Saving..." : "💾 Save Changes"}
          </button>
          <button
            type="button"
            onClick={() => navigate(`/interviews/${interviewId}`)}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </form>
    </Layout>
  );
}
